<template>
    <div>
        <el-row style="margin-top: 30px;">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="预算可修改日期范围" name="first">
                    <tab1 ref="tab1" :from="from" v-if="!is_edit"></tab1>
                </el-tab-pane>
                <el-tab-pane label="预算可使用范围" name="second">
                    <tab2 ref="tab2" :from="from" v-if="!is_edit"></tab2>
                </el-tab-pane>
            </el-tabs>
        </el-row>
    </div>
</template>

<script>

import tab1 from "./tabs/tab1.vue";
import tab2 from "./tabs/tab2.vue";
export default {
    components: {
        tab1,tab2
    },
    data() {
        return {
            //列表相关
            page_num: 1,
            page_size: 10,
            total: 0,
            tableData: [],
            is_edit: false,
            activeName: "first",

            //页面相关
            dialogVisible: false,
        };
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        }
    }

}
</script>

<style scoped="scoped">
>>>.el-button:hover {
    background-color: #FFFFFF;
}

>>>.el-button:focus {
    background-color: #FFFFFF;
}

>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #006E4B;
}

>>>.el-input__inner:focus {
    border-color: #006E4B;
}

>>>.el-select .el-input.is-focus .el-input__inner {
    border-color: #006E4B;
}

>>>.el-checkbox__input.is-checked .el-checkbox__inner,
>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #006E4B;
    border-color: #006E4B;
}

>>>.el-checkbox__inner:hover {
    border-color: #006E4B;
}
</style>



// WEBPACK FOOTER //
// setter.vue?749e27f2